import { render } from "./HeroiconsSolidShare.vue?vue&type=template&id=04933b0c"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidShare.vue"]])

export default __exports__